var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorderRay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 66,
    viewBox: "0 0 454 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1857_4475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.043 37.1912C56.5811 37.4845 142.41 36.3406 186.014 36.6317C186.082 36.6321 186.143 36.6599 186.19 36.7086L191.517 42.2653C191.631 42.3838 191.826 42.3625 191.911 42.2223L208.867 14.3637C208.966 14.2007 209.204 14.2045 209.298 14.3706L221.99 36.7955C222.087 36.967 222.336 36.964 222.428 36.7901L225.271 31.4649C225.366 31.287 225.622 31.2889 225.714 31.4682L236.012 51.4825C236.112 51.6778 236.398 51.6579 236.47 51.4506L247.818 18.986C247.889 18.784 248.164 18.7583 248.271 18.9437L258.708 37.0659C258.753 37.1434 258.835 37.1912 258.925 37.1912H440.043",
    stroke: "url(#paint0_linear_1857_4475)",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.043 37.1912C56.5811 37.4845 142.41 36.3406 186.014 36.6317C186.082 36.6321 186.143 36.6599 186.19 36.7086L191.517 42.2653C191.631 42.3838 191.826 42.3625 191.911 42.2223L208.867 14.3637C208.966 14.2007 209.204 14.2045 209.298 14.3706L221.99 36.7955C222.087 36.967 222.336 36.964 222.428 36.7901L225.271 31.4649C225.366 31.287 225.622 31.2889 225.714 31.4682L236.012 51.4825C236.112 51.6778 236.398 51.6579 236.47 51.4506L247.818 18.986C247.889 18.784 248.164 18.7583 248.271 18.9437L258.708 37.0659C258.753 37.1434 258.835 37.1912 258.925 37.1912H440.043",
    stroke: "url(#paint1_linear_1857_4475)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1857_4475",
    x: 0.0361328,
    y: 0.244141,
    width: 453.007,
    height: 65.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_1857_4475"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1857_4475",
    x1: 382.543,
    y1: 36.7146,
    x2: 74.5438,
    y2: 37.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15BFFD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245211,
    stopColor: "#15BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507389,
    stopColor: "#15BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838894,
    stopColor: "#15BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15BFFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1857_4475",
    x1: 382.543,
    y1: 36.7146,
    x2: 74.5438,
    y2: 37.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15BFFD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245211,
    stopColor: "#15BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507389,
    stopColor: "#15BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838894,
    stopColor: "#15BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15BFFD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderRay);
export default __webpack_public_path__ + "static/media/borderRay.1d77ca776032bc71a1a18648e5658ec6.svg";
export { ForwardRef as ReactComponent };